import styles from "./Badge.module.css";

/**
 * `edge` / `drift` are the §05 functional pair and belong to charts and
 * do/don't examples. `signal` is for product states (LIVE, BETA). `neutral` is
 * everything else. As with StatValue, violet is not an option.
 */
export type BadgeTone = "edge" | "drift" | "neutral" | "signal";

interface Props {
  children: React.ReactNode;
  tone?: BadgeTone;
}

export function Badge({ children, tone = "neutral" }: Props) {
  return <span className={`${styles.badge} ${styles[tone]}`}>{children}</span>;
}
